import { NavLink } from "react-router";

export default function NavbarLink(props: any) {
  return (
    <NavLink to={props.to} className="py-3 px-4 lg:text-white" title={props.title}>
      {props.title}
    </NavLink>
  )
}